export const enum PagesListEnum {
  fieldsList = 'FieldsList',
  createField = 'CreateField',
  notesList = 'NotesList',
  createNote = 'CreateNote',
  devicesList = 'DevicesList',
  deviceDetails = 'DeviceDetails',
}
